<template >
  <div v-loading="showFlag">
    <t-card
      ><div>
        <!-- ドル(USD)⇒円(JPY) -->
        <t-row class="table_common" v-show="this.USDToJPY != '0'">
          <t-col :span="24">
            <t-input v-model="USDToJPY" :disabled="true" style="margin: 5px 0">
              <template slot="prepend"
                ><span style="width: 200px; display: inline-block">
                  {{ $t("resource.rateReferenceInfo.USDToJPY") }}</span
                >
              </template>
            </t-input>
          </t-col>
        </t-row>

        <!-- 元(CNY)⇒円(JPY) -->
        <t-row class="table_common" v-show="this.CNYToJPY != '0'">
          <t-col :span="24">
            <t-input v-model="CNYToJPY" :disabled="true" style="margin: 5px 0">
              <template slot="prepend"
                ><span style="min-width: 200px; display: inline-block">
                  {{ $t("resource.rateReferenceInfo.CNYToJPY") }}</span
                >
              </template>
            </t-input>
          </t-col>
        </t-row>

        <!-- バーツ(THB)⇒円(JPY) -->
        <t-row class="table_common" v-show="this.THBToJPY != '0'">
          <t-col :span="24">
            <t-input v-model="THBToJPY" :disabled="true" style="margin: 5px 0">
              <template slot="prepend"
                ><span style="min-width: 200px; display: inline-block">
                  {{ $t("resource.rateReferenceInfo.THBToJPY") }}</span
                >
              </template>
            </t-input>
          </t-col>
        </t-row>

        <div
          v-show="
            !(
              this.USDToJPY == '0' &&
              this.CNYToJPY == '0' &&
              this.THBToJPY == '0'
            )
          "
        >
          <t-row
            class="table_common"
            style="height: 40px"
            v-show="this.USDToJPY == '0'"
          >
            <t-col :span="24"> <span>&nbsp;</span></t-col></t-row
          >
          <t-row
            class="table_common"
            style="height: 40px"
            v-show="this.CNYToJPY == '0'"
          >
            <t-col :span="24"> <span>&nbsp;</span></t-col></t-row
          >
          <t-row
            class="table_common"
            style="height: 40px"
            v-show="this.THBToJPY == '0'"
          >
            <t-col :span="24"> <span>&nbsp;</span></t-col></t-row
          >
        </div>
        <div
          v-show="
            this.USDToJPY == '0' && this.CNYToJPY == '0' && this.THBToJPY == '0'
          "
        >
          <t-row style="width: 100%; margin-top: 75px; height: 75px">
            <span>{{ $t("message.NUMBER.ONLY_JPY") }}</span></t-row
          >
        </div>

        <!-- 同期ボタン -->
        <t-row>
          <t-col :span="24" class="right">
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              :disabled="productNotEditFlg"
              @click="getAllRateProc('2')"
            >
              <i class="el-icon-refresh"></i>
              {{ $t("resource.rateReferenceInfo.synchronizeButton") }}
            </t-button>
          </t-col>
        </t-row>
      </div></t-card
    >
  </div>
</template>
<script>
import { t } from "@/locales";
import { getAllRate } from "@/services/number";
import { Message } from "@tellus/component";
export default {
  data() {
    return {
      USDToJPY: "0",
      CNYToJPY: "0",
      THBToJPY: "0",
      showFlag: false,
    };
  },

  mounted() {
    this.init();
  },

  props: {
    nbQuoteNo: {
      Type: String,
    },

    productNotEditFlg: {
      Type: Boolean,
    },
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      this.getAllRateProc("1");
    },

    //すべてのレートを取得する
    getAllRateProc(type) {
      //type=1:当該採番データのレートの取得
      //type=2:最新の「レート」の取得
      getAllRate({
        nbQuoteNo: this.nbQuoteNo,
        getRateType: type,
      })
        .then((res) => {
          if (res != null) {
            //[USDToJPY;CNYToJPY;THBToJPY]
            this.USDToJPY = res.split(";")[0];
            this.CNYToJPY = res.split(";")[1];
            this.THBToJPY = res.split(";")[2];
          }
          if (type == "2") {
            this.confirmClick();
          }
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //同期ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      //[USDToJPY;CNYToJPY;THBToJPY]
      var result = this.USDToJPY + ";" + this.CNYToJPY + ";" + this.THBToJPY;
      this.$emit("ok", result);
    },
  },
};
</script>

